
define('text!presentation/common/wysiwygEditor/views/wysiwygEditor.html',[],function () { return '<textarea data-bind="wysiwygEditorThemed: {styles: styles, content: content, value: value, enabled: enabled}"></textarea>\n';});

